import Resource from '@/api/resources/Resource'

class ComplementaryInformationAttachmentService extends Resource {
    async addAttachment(laboratoryId, caseId, complementaryId, request) {
        const response = await this.axios.post(
            `/laboratories/${laboratoryId}/cases/${caseId}/complementaries/${complementaryId}/information/attachments`,
            request)
        return response.data
    }

    async getAttachments(laboratoryId, caseId, complementaryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/complementaries/${complementaryId}/information/attachments`)
        return response.data
    }

    async deleteAttachment(laboratoryId, caseId, complementaryId, descriptionAttachmentId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/cases/${caseId}/complementaries/${complementaryId}/information/attachments/${descriptionAttachmentId}`)
        return response.data
    }
}

export default new ComplementaryInformationAttachmentService()
